module.exports = __webpack_public_path__ + "3de18571d2bb997f595bb8011022afa3.svg";